"use strict";
/* istanbul ignore file -- as this exports constants that are unused in this package. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMON_OBJECT_SRC_VALUES = exports.COMMON_WORKER_SRC_VALUES = exports.COMMON_FRAME_ANCESTORS_VALUES = exports.COMMON_FRAME_SRC_VALUES = exports.COMMON_FONT_SRC_VALUES = exports.COMMON_DEFAULT_SRC_VALUES = exports.COMMON_STYLE_SRC_VALUES = exports.COMMON_SCRIPT_SRC_VALUES = exports.COMMON_MEDIA_SRC_VALUES = exports.COMMON_IMAGE_SRC_VALUES = exports.COMMON_CONNECT_SRC_VALUES = void 0;
exports.COMMON_CONNECT_SRC_VALUES = [
    "'self'",
    "blob:",
    // for sending graphene metrics
    "https://gcp.api.snapchat.com",
    // blizzard
    "https://web-frontend-dot-sc-analytics.appspot.com",
    // AB exposure logging
    "https://aws.api.snapchat.com",
    // google analytics
    "https://*.google-analytics.com",
    "https://*.analytics.google.com",
    // google tag manager
    "https://stats.g.doubleclick.net",
    "https://*.googletagmanager.com",
    // cookie settings
    "https://www.snapchat.com",
    // snap reporting
    "https://app.snapchat.com",
    // sentry
    "https://sentry.sc-prod.net",
    // Blizzard metrics reporting
    "https://us-central1-gcp.api.snapchat.com",
    "https://staging-us-central1-gcp.api.snapchat.com",
    // WPO reporting
    "https://staging-web-gcp.snap-dev.net",
    "https://web.snapchat.com",
    // to get authed state for metrics
    "https://accounts.snapchat.com",
    // for enabling web-sockets in safari
    "ws:",
    "wss:",
    "https://static.snapchat.com",
    // sentry
    "https://sentry.sc-prod.net",
    // cookie popup
    "https://cdn.contentful.com",
    // report metrics
    "https://story.snapchat.com",
    // arkose
    "https://snap-api.arkoselabs.com",
];
exports.COMMON_IMAGE_SRC_VALUES = [
    "'self' blob: data:",
    // snapchat ghost logo for the nav
    "https://support-tools.storage.googleapis.com",
    // snapcodes
    "https://www.snapchat.com",
    "https://story.snapchat.com",
    // logos
    "https://cf-st.sc-cdn.net",
    // google analytics
    "https://*.google-analytics.com",
    // google tag manager
    "https://*.googletagmanager.com",
    // stories everywhere player svg icons
    "data:",
    // GA/GTM, TODO: do we have to specify each country subdomain? listing some of the most popular domains
    "https://www.google.com",
    "https://www.google.co.uk",
    "https://www.google.com.sa",
    "https://www.google.ca",
    "https://www.google.fr",
    "https://www.google.com.no",
    "https://www.google.com.au",
    // for favicon
    "https://static.snapchat.com",
    // 3D bitmojis
    "https://images.bitmoji.com",
    // Profile pictures
    "https://impala-media-production.s3.amazonaws.com",
];
exports.COMMON_MEDIA_SRC_VALUES = [
    "https://bolt-gcdn.sc-cdn.net",
    "https://static.snapchat.com",
    "https://s.sc-cdn.net",
    "https://cf-st.sc-cdn.net",
    "blob:",
];
exports.COMMON_SCRIPT_SRC_VALUES = [
    "'self'",
    "https://static.snapchat.com",
    // google analytics
    "https://www.google-analytics.com",
    // google tag manager
    "https://*.googletagmanager.com",
    // hash for google analytics script
    "'sha256-dQJQsgrl3uMVvy2BJYsaNKb5aPwwZP1Hxm/h8nPMYU8='",
    "'sha256-W180Lw4gMizxEUHmEThR7QFnAWtmFgcFnXafbGOe27I='",
    "'sha256-T+mJpzkspYbS2c9j2qrgyezx0+bxueaYNJwVB75pe3Y='",
    // hash for google analytics v4 script
    "'sha256-5rMxh1U6sIDlVjmobBQY89QTC9nNeK3hd9dsXpD2AYE='",
    "'sha256-SlyXqNpddFY9lxbguST5m22HifGELYV1FYec8XhHUkk='",
    "'sha256-FhUvlSz0BXj4r8M1nXAkVXmbcxiWrUXB6vNbCZ8A0Zk='",
    "'sha256-2LmOILM2HIS9pJC380owRlOYo+c5WOuuNL7oEMLss2I='",
    "'sha256-MNn0HyJxuyKnyn0lPM1hCzPzycraTm0TXEqX1khh/7k='", // GA4 init script
];
exports.COMMON_STYLE_SRC_VALUES = ["'self'", "https://static.snapchat.com", "'unsafe-inline'"];
exports.COMMON_DEFAULT_SRC_VALUES = ["'self'"];
exports.COMMON_FONT_SRC_VALUES = [
    "'self'",
    "https://snap-design-system.storage.googleapis.com",
    "https://ads-interfaces.sc-cdn.net",
    "https://static.snapchat.com",
];
// We need to allow framing Arkose on every page for sidebar sign-in
exports.COMMON_FRAME_SRC_VALUES = [
    "https://iframe.arkoselabs.com",
    "https://snap-api.arkoselabs.com",
    "https://client-api.arkoselabs.com",
];
exports.COMMON_FRAME_ANCESTORS_VALUES = ["'none'"];
exports.COMMON_WORKER_SRC_VALUES = ["'self'", "blob:"];
exports.COMMON_OBJECT_SRC_VALUES = ["'none'"];
//# sourceMappingURL=csp-headers.js.map